import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X, Truck, Tag, Sparkles } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PromoBanner = () => {
  const [settings, setSettings] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Check if banner was dismissed in this session
    const wasDismissed = sessionStorage.getItem('promo_banner_dismissed');
    if (wasDismissed) {
      setDismissed(true);
      return;
    }

    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        setSettings(response.data);
      } catch (error) {
        console.error('Failed to fetch settings:', error);
      }
    };
    fetchSettings();
  }, []);

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('promo_banner_dismissed', 'true');
  };

  if (dismissed || !settings?.promo_banner_enabled) {
    return null;
  }

  const bgColor = settings?.promo_banner_bg_color || '#8B4513';
  const text = settings?.promo_banner_text || 'Free shipping on orders over $50!';
  const link = settings?.promo_banner_link || '/products';

  // Determine icon based on text content
  const getIcon = () => {
    const lowerText = text.toLowerCase();
    if (lowerText.includes('shipping') || lowerText.includes('delivery')) {
      return <Truck className="h-4 w-4" />;
    }
    if (lowerText.includes('%') || lowerText.includes('off') || lowerText.includes('sale')) {
      return <Tag className="h-4 w-4" />;
    }
    return <Sparkles className="h-4 w-4" />;
  };

  return (
    <div 
      className="relative py-2.5 px-4 text-center text-white text-sm font-medium animate-fade-in"
      style={{ backgroundColor: bgColor }}
      data-testid="promo-banner"
    >
      <Link 
        to={link} 
        className="inline-flex items-center gap-2 hover:underline"
        data-testid="promo-banner-link"
      >
        {getIcon()}
        <span>{text}</span>
        <span className="hidden sm:inline">→</span>
      </Link>
      <button
        onClick={handleDismiss}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-white/20 rounded-full transition-colors"
        aria-label="Dismiss banner"
        data-testid="promo-banner-close"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
